module.exports = function(app) {

    app.controller('pages.forgotPassword.accountRecovery.step3', ['$state', '$scope', 'userService', 'phoneNumbers', 'coremetrics', 'brand',
        function($state, $scope, userService, phoneNumbers, coremetrics, brand) {

            var user = $state.params.user || "";
            if (user === "" || !(user && user.userToken && user.userToken.length > 0)) {
                $scope.$parent.goto(1, false);
            }

            var phoneNumber = "the number on the back of your member ID card.";
            if ($scope.brandData.phoneNumbers && $scope.brandData.phoneNumbers.technical) {
                phoneNumber = $scope.brandData.phoneNumbers.technical;
            }
            $scope.isMN = brand.current.ubk === 6010;
            $scope.showCodeEntryForm = false;
            $scope.showContactSelectForm = true;
            $scope.showTextLegalMessage = false;
            $scope.footerMessage = {
                header: "",
                message: "",
                iconClass: "",
                show: false
            };

            $scope.user = {
                selectedContactType: "",
                verificationCode: ""
            };

            $scope.contactTypeList = [
                {
                    type: 'email',
                    contactList: [
                        {
                            contact: { type: 'email', communicationMethod: 'email' },
                            maskedValue: user.email
                        }
                    ]
                }
            ];

            // phoneNumbers of the userService is called from the state's resolve.
            if (phoneNumbers && phoneNumbers.data && phoneNumbers.data.payload && phoneNumbers.data.payload.phoneNumbers) {
                var phoneContactType = { type: 'phone', contactList: [ ] };
                user.phoneNumbers = phoneNumbers.data.payload.phoneNumbers;

                for (var i = 0; i <= phoneNumbers.data.payload.phoneNumbers.length; i++) {
                    var aPhone = phoneNumbers.data.payload.phoneNumbers[i];

                    if (aPhone && aPhone.number && aPhone.number.length > 0) {
                        phoneContactType.contactList.push({ contact: { type: aPhone.type, communicationMethod: 'sms' }, maskedValue: aPhone.number });
                        $scope.showTextLegalMessage = true;
                    }
                }
                $scope.contactTypeList.push(phoneContactType);
            }

            $scope.requestCode = function() {
                if ($scope.contactSelectionForm.$valid) {

                    $scope.footerMessage.show = false;
                    $scope.disableButtons = true;

                    userService.requestVerificationCode(user.userToken, $scope.user.selectedContactType).then(
                        function(response) {
                            var baseMessage = userService.parseBaseMessage(response);

                            if (baseMessage && baseMessage.returnCode === 200) {
                                $scope.disableButtons = false;
                                $scope.showCodeEntryForm = true;
                                $scope.showContactSelectForm = false;
                                coremetrics.pageviewTag('FORGOT PASSWORD MATCH VERIFICATION CODE', 'FORGOT');
                            } else {
                                handleError(response, "requestVerificationCode");
                            }
                        },
                        function(error) {
                            $scope.disableButtons = false;
                            handleError(error, "requestVerificationCode");
                        }
                    );
                }
            };

            $scope.nextStep = function() {
                coremetrics.elementTag('FORGOT: CONTINUE STEP 3', 'FORGOT');

                if ($scope.verificationCodeForm.$valid) {
                    $scope.footerMessage.show = false;
                    $scope.disableButtons = true;

                    userService.verifyCode(user.userToken, $scope.user.verificationCode).then(
                        function(response) {
                            $scope.disableButtons = false;
                            var baseMessage = userService.parseBaseMessage(response);

                            if (baseMessage && baseMessage.returnCode === 200) {
                                user.verificationCode = $scope.user.verificationCode;
                                $scope.$parent.goto(4, true, {user : user});

                                // Finish step 3 conversion event
                                coremetrics.finishConversion('STEP 3 VERIFICATION CODE', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');
                            } else {
                                handleError(response, "verifyCode");
                            }
                        },
                        function(error) {
                            $scope.disableButtons = false;
                            handleError(error, "verifyCode");
                        }
                    );
                }
            };

            var handleError = function(response, method) {
                var baseMessage = userService.parseBaseMessage(response);

                if (method === "verifyCode" && baseMessage && baseMessage.returnCode === 409) {
                    // Match Verification code, 409 - No Match Found.
                    userService.showFooterMessage($scope.footerMessage, '', '<span data-aem-content="RECOVERY_STEP3B_NO_MATCH_TEXT"></span>', true);

                } else if (method === "verifyCode" && baseMessage && baseMessage.returnCode === 412) {
                    // Match Verification code, 412 - User has exceeded # of match requests allowed.
                    userService.showFooterMessage($scope.footerMessage, '', '<span data-aem-content="RECOVERY_STEP3B_NO_MATCH_THREE_ATTEMPTS_TEXT as errorText">{{errorText}}' + ' ' + phoneNumber + '</span>', true);

                } else if (method === "requestVerificationCode" && baseMessage && baseMessage.returnCode === 412) {
                    // Request Verification code, 412 - User has exceeded # of code requests allowed.
                    // Take the user to the code entry form, the last code requested is still valid.
                    $scope.disableButtons = false;
                    $scope.showCodeEntryForm = true;
                    $scope.showContactSelectForm = false;
                    userService.showFooterMessage($scope.footerMessage, '', '<span data-aem-content="RECOVERY_STEP3B_REQUEST_TOO_MANY_CODES_TEXT as errorText">{{errorText}}' + ' ' + phoneNumber + '</span>', true);
                    coremetrics.pageviewTag('FORGOT PASSWORD MATCH VERIFICATION CODE', 'FORGOT');  //no value for above ID.

                } else if (baseMessage && baseMessage.returnCode === 404) {
                    var context = (baseMessage.businessContext && baseMessage.businessContext.length > 0) ? baseMessage.businessContext : 'UNKNOWN_404';
                    $scope.$parent.goto(1, false, { error: { code: baseMessage.returnCode, context: context } });

                } else {
                    showGeneralErrorMessage();
                }
            };

            $scope.getNewCode = function() {
                coremetrics.elementTag('FORGOT: GET NEW CODE', 'FORGOT');
                $scope.previousForm();
            };

            $scope.backButton = function() {
                resetForms();
                $scope.$parent.goto(2, true, {user : user});
            };

            $scope.previousForm = function() {
                resetForms();
                $scope.footerMessage.header = "";
                $scope.footerMessage.message = "";
                $scope.footerMessage.show = false;
                $scope.showCodeEntryForm = false;
                $scope.showContactSelectForm = true;
                coremetrics.pageviewTag('FORGOT PASSWORD REQUEST VERIFICATION CODE', 'FORGOT');
            };

            var resetForms = function() {
                $scope.user.selectedContactType = "";
                $scope.user.verificationCode = "";
                $scope.verificationCodeForm.$setUntouched();
                $scope.verificationCodeForm.$setPristine();
                $scope.contactSelectionForm.$setUntouched();
                $scope.contactSelectionForm.$setPristine();
            };

            var showGeneralErrorMessage = function() {
                userService.showFooterMessage($scope.footerMessage, "", "We are having trouble processing your request right now. Try again in a few minutes. " +
                    "If the problem continues, please call the number on the back of your member ID card.", true);
            };

            // Start step 3 conversion event
            coremetrics.startConversion('STEP 3 VERIFICATION CODE', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');
        }
    ]);
};